export const A1_CARD = 'A1_CARD';

export const CARE_NEED_CARD = 'CARE_NEED_CARD';

export const NURSE_DEPLOYMENT_CARD = 'NURSE_DEPLOYMENT_CARD';

export const VISIT_CARD = 'VISIT_CARD';
